import React from "react";
import "./TurnYC.css";
import { useState } from "react";

const TurnYC = () => {
  const [formData, setFormData] = useState({
    fname: "",
    lname: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: undefined }));
  };

  const validate = () => {
    const err = {};
    if (!formData.fname.trim()) err.fname = "First name is required";
    if (!formData.lname.trim()) err.lname = "Last name is required";

    const email = formData.email.trim();
    const emailRegex = /^\S+@\S+\.\S+$/;
    if (!email) err.email = "Email is required";
    else if (!emailRegex.test(email)) err.email = "Enter a valid email";

    const phoneDigits = (formData.phone || "").replace(/\D/g, "");
    if (!phoneDigits) err.phone = "Phone is required";
    else if (!/^\d{10,15}$/.test(phoneDigits))
      err.phone = "Enter a valid phone (10-15 digits)";

    if (!formData.message.trim()) err.message = "Message is required";

    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    const { fname, lname, email, phone, message } = formData;
    const subject = encodeURIComponent("Contact Form Submission");
    const body = encodeURIComponent(
      `Name: ${fname} ${lname}\nEmail: ${email}\nPhone: ${phone}\n\nMessage:\n${message}`
    );

    const mailto = `mailto:info@corefitplus.com?subject=${subject}&body=${body}`;

    // try open in same tab (most reliable for invoking default mail client)
    try {
      window.location.href = mailto;
      // also attempt window.open (some browsers prefer this)
      const w = window.open(mailto, "_blank");
      if (w === null) {
        // popup blocked — fallback after short delay
        setTimeout(() => {
          // copy mailto to clipboard and show instruction
          if (navigator.clipboard) {
            navigator.clipboard
              .writeText(mailto)
              .then(() =>
                alert(
                  "Unable to open your mail client. Mailto link copied to clipboard. Paste it into your browser address bar or email client's 'To' field."
                )
              )
              .catch(() =>
                alert(
                  "Unable to open mail client. Please copy and paste this link manually:\n" +
                    mailto
                )
              );
          } else {
            alert(
              "Unable to open mail client. Please copy and paste this link manually:\n" +
                mailto
            );
          }
        }, 500);
      }
    } catch (err) {
      // unexpected error — show mailto so user can copy manually
      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(mailto)
          .then(() =>
            alert(
              "Unable to open your mail client. Mailto link copied to clipboard."
            )
          )
          .catch(() =>
            alert(
              "Unable to open mail client. Please copy and paste this link manually:\n" +
                mailto
            )
          );
      } else {
        alert(
          "Unable to open mail client. Please copy and paste this link manually:\n" +
            mailto
        );
      }
    }

    // optional: clear form (keeps UX same as before)
    setFormData({ fname: "", lname: "", email: "", phone: "", message: "" });
  };

  return (
    <>
      <div className="tyc1">
        <div className="tyc2">
          <p className="tyc3"> Turn your passion into your career!</p>
          <p className="tyc4" style={{ fontSize: "21px" }}>
            A 450-hour Comprehensive Pilates Certification Program
          </p>
        </div>
        <div className="tyc5">
          <p className="tyc6">WHAT IT IS?</p>
          <div className="tyc7">
            <p className="tyc4">
              Corefit Plus Pilates offers a 450-hour teacher training program
              covering all Pilates apparatus: Mat, Reformer, Jumpboard,
              Cadillac, Chair, Ladder Barrel, Spine Corrector, and Magic Circle.
              The program blends in-person training, independent study, and
              online learning to give you a complete Pilates education.
            </p>
          </div>
        </div>
      </div>
      <div className="tyc5">
        <p className="tyc6">WHY GET CERTIFIED?</p>
        <div className="tyc7">
          <p className="tyc4">
            Becoming a certified Pilates instructor opens doors to endless
            possibilities. Whether you&#39;re building a full-time career,
            pursuing a flexible side hustle, or deepening your personal
            practice, our program empowers you with the skills to succeed and
            uncover your body&#39;s full potential.
          </p>
        </div>
      </div>
      <div className="tyc5">
        <p className="tyc6">WHAT MAKES COREFIT PLUS DIFFERENT?</p>
        <div className="tyc7">
          <div className="tyc9">
            <ul>
              <li>
                Global Industry Standards – Meets requirements for top Pilates
                certifications
              </li>
              <li>
                Certification and Training – Our training program also includes
                NPCP-certified instructors, and Corefit Plus is proudly listed
                on the NPCP website as the first studio in India to achieve
                this. If you choose to get certified through the NPCP, we guide
                and mentor you through the entire process.
              </li>
              <li>
                Mentorship for Life – Ongoing support even after certification
              </li>
              <li>
                Studio Access – Dedicated hours for self-practice and teacher
                training
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="tyc5">
        <p className="tyc6">WHAT YOU’LL LEARN</p>
        <p className="tyc4">
          Divided into 6 modules—History &amp; Anatomy, Mat, Reformer, Cadillac,
          Chair, and Barrel/Spine Corrector—you’ll learn:
        </p>
        <div className="tyc7">
          <div className="tyc9">
            <ul>
              <li>Pilates principles &amp; techniques across all equipment</li>
              <li>Class programming &amp; modifications for all levels</li>
              <li>
                How to work with props (magic circle, weights, balls, etc.)
              </li>
              <li>
                Anatomy &amp; movement principles (planes of motion,
                concentric/eccentric movements)
              </li>
              <li>
                Teaching methods—group classes, one-on-one sessions, and special
                populations
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="tyc5">
        <p className="tyc6">HOW DOES THE TRAINING WORK?</p>
        <div className="tyc7">
          <div className="tyc9">
            <ul>
              <li>
                6 modules covered over 1 month of classroom: In studio we will
                cover Anatomy, History of Pilates, Scope of Practice, and a
                breakdown of each exercise according to choreography, muscle
                focus, and contraindications. We will also spend time learning
                how to put together private training sessions, and group
                classes.
              </li>
              <li>
                Studio access for self practice and teacher training hours: Each
                program will require you to spend a set amount of hours
                practicing in class, teaching yourself through your manuals, or
                practicing from approved online resources.
              </li>
              <li>
                Mentorship throughout the program and beyond: Our commitment to
                your success doesn&#39;t end when you graduate. As a Corefit
                Plus Pilates certified instructor, you&#39;ll receive ongoing
                mentorship and support to help you thrive in your teaching
                journey.
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="tyc5">
        <p className="tyc6">WHAT’S NEXT?</p>
        <p className="tyc4">
          Upon completion, you’ll be ready to sit for the National Pilates
          Certification Program (NPCP) exam and teach in:
        </p>
        <div className="tyc7">
          <div className="tyc9">
            <ul>
              <li>Big gyms &amp; boutique studios worldwide</li>
              <li>Private &amp; small group settings</li>
              <li>Corefit Plus Pilates studios</li>
            </ul>
          </div>
        </div>
        <p className="tyc4">
          Start your journey towards becoming a certified Pilates Instructor
          today!
        </p>
      </div>
      <div className="cun2">
        <div className="tycc12">
          <h4 style={{ fontFamily: "'Demibolds',sans-serif", color: "black" }}>
            CONTACT FORM <hr className="cu9" />
          </h4>
          <div className="tycc13">
            <form onSubmit={handleSubmit} noValidate>
              <div className="tycc14">
                <div>
                  <input
                    onChange={handleChange}
                    value={formData.fname}
                    type="text"
                    name="fname"
                    placeholder="First Name*"
                  />
                  {errors.fname && (
                    <div className="form-error">{errors.fname}</div>
                  )}

                  <input
                    onChange={handleChange}
                    value={formData.lname}
                    type="text"
                    name="lname"
                    placeholder="Last Name*"
                  />
                  {errors.lname && (
                    <div className="form-error">{errors.lname}</div>
                  )}
                </div>
                <div>
                  <input
                    onChange={handleChange}
                    value={formData.email}
                    type="email"
                    name="email"
                    placeholder="Email*"
                  />
                  {errors.email && (
                    <div className="form-error">{errors.email}</div>
                  )}

                  <input
                    onChange={handleChange}
                    value={formData.phone}
                    type="tel"
                    name="phone"
                    placeholder="Phone*"
                  />
                  {errors.phone && (
                    <div className="form-error">{errors.phone}</div>
                  )}
                </div>
              </div>
              <textarea
                onChange={handleChange}
                value={formData.message}
                name="message"
                rows="7"
                placeholder="Type your comment*"
              ></textarea>
              {errors.message && (
                <div className="form-error">{errors.message}</div>
              )}
              <br />
              <br />
              <button type="submit">Submit</button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default TurnYC;
